export enum OrganizationTypeEnum {
  PHYSICAL = 'PHYSICAL',
  INDIVIDUAL = 'INDIVIDUAL',
  JURIDICAL = 'JURIDICAL',
}
